var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { ref: "modal", staticClass: "modal fade" }, [
    _c(
      "div",
      { staticClass: "modal-dialog modal-xs", attrs: { role: "document" } },
      [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("h4", { staticClass: "modal-title" }, [
              _c("b", [_vm._v(_vm._s(_vm.$t("txtMove")))])
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "close",
                attrs: { type: "button" },
                on: { click: _vm.dismiss }
              },
              [_vm._v("×")]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-body" },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("cellParent")) +
                  "\n                "
              ),
              _c("v-select", {
                attrs: {
                  options: _vm.cellsForVSelect,
                  label: "name",
                  reduce: e => e.id,
                  clearable: false
                },
                model: {
                  value: _vm.parentId,
                  callback: function($$v) {
                    _vm.parentId = $$v
                  },
                  expression: "parentId"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              { staticClass: "btn btn-secondary", on: { click: _vm.dismiss } },
              [_vm._v(_vm._s(_vm.$t("btnCancel")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "btn btn-primary", on: { click: _vm.move } },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("txtMove")) +
                    "\n                "
                )
              ]
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }